<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.study_group_category_id}">
      <label>Select Access Group Category:</label>
      <select :value="study_group_category_id" name="study_group_category_id" class="form-control" @change="handleCategoryChange">
        <option value="" />
        <option v-for="category in config.studyCategories" :value="category.id">
          {{ category.name }}
        </option>
      </select>
    </div>
    <div v-if="study_group_category_id" :class="{'has-error':errors.study_group_id}">
      <label>Select Access Group:</label>
      <select v-model="studyGroupId" name="study_group_id" class="form-control" @change="handleChange">
        <option value="" />
        <option v-for="group in filteredGroups" :value="group.id">
          {{ group.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String,
      study_group_category_id: [Number, String],
      study_group_id: [Number, String]
    },
    data: function() {
      return {
        studyGroupId: this.study_group_id
      }
    },
    computed: {
      filteredGroups: function() {
        return this.config.studyGroups.filter(group => group.category_id.toString() === this.study_group_category_id.toString()) ?? [];
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isNumber(this.study_group_category_id)) {
          this.errors.study_group_category_id = "Please select a Study Group Category.";
        }

        if (!this.isNumber(this.studyGroupId)) {
          this.errors.study_group_id = "Please select a Study Group.";
        }
        
        return Object.keys(this.errors).length === 0;
      },
      handleCategoryChange: function(event) {
        this.studyGroupId = null;

        this.handleChange(event);
      }
    }
  };
</script>
